import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UCheckboxComponent } from './u-checkbox.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_RIPPLE_GLOBAL_OPTIONS, RippleGlobalOptions } from '@angular/material/core';

const globalRippleConfig: RippleGlobalOptions = {
  disabled: true,
};

@NgModule({
  declarations: [UCheckboxComponent],
  imports: [FormsModule, CommonModule, MatCheckboxModule, ReactiveFormsModule],
  exports: [UCheckboxComponent],
  providers: [{ provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: globalRippleConfig }],
})
export class UCheckboxModule {}
